<template>
  <div class="sections">
    <section id="start" class="uk-margin-large-top uk-margin-medium-bottom">
      <div class="uk-container uk-container-large">
        <div class="uk-align-center uk-width-2-3@m">
          <router-link to="/" class="uk-button-text uk-text-bold"><span class="uk-margin-small-right" data-uk-icon="chevron-left"></span>zur&uuml;ck</router-link>
          <h1 class="uk-h2">{{configurator.title}}</h1>
          <div id="configurator-text" v-html="configurator.body_text"></div>
        </div>
      </div>
    </section>
    <transition appear>
      <choose-price></choose-price>
    </transition>
    <transition appear>
      <choose-stop></choose-stop>
    </transition>
    <transition appear>
      <choose-pipe></choose-pipe>
    </transition>
    <transition appear>
      <your-sponsorship></your-sponsorship>
    </transition>
    <checkout-sponsorship></checkout-sponsorship>
    <transition appear>
      <gallery></gallery>
    </transition>
  </div>
</template>

<script>
import {CONFIGURATOR} from '../../constants/graphql'
import ChoosePrice from './ChoosePrice'
import ChooseWork from './ChooseWork'
import ChooseStop from './ChooseStop'
import ChoosePipe from './ChoosePipe'
import YourSponsorship from './YourSponsorship'
import CheckoutSponsorship from './CheckoutSponsorship'
import Gallery from '../Global/Gallery'
import {mapGetters} from 'vuex'

export default {
  name: 'ConfiguratorPage',
  components: {ChoosePrice, ChooseWork, ChooseStop, ChoosePipe, YourSponsorship, CheckoutSponsorship, Gallery},
  data () {
    return {
      configurator: {},
      loading: 0
    }
  },
  apollo: {
    configurator: {
      query: CONFIGURATOR,
      update (data) {
        return data.configurator.list[0]
      }
    }
  },
  computed: {
    ...mapGetters(['chosenPrice', 'chosenWork', 'chosenStop', 'chosenPipes'])
  },
  methods: {}
}
</script>

<style lang="scss">
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  #start {
    p {
      @include fontSize(21px);
    }
    h1 {
      @include fontSize(35px);
    }
  }
  [data-uk-icon*="chevron"] {
    svg {
      polyline {
        stroke-width: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/ConfiguratorPage.vue